module.exports = __webpack_public_path__ + "img/banner-20.852a9e6a.jpg";